import { baseUrl } from "features/api";

export const stackImagesUrl = `${baseUrl}stack-images/`;
